module.exports = __webpack_public_path__ + "media/promo/lum2021/images/2ndm-16e557d47d4b6242331fbeb20fcdc0d0.jpg";